import { render } from "./Header.vue?vue&type=template&id=60c716d6&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=60c716d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-60c716d6"

export default script